<template>
  <fo-layout>
    <div class="filter-input" ref="filter">
      <industry v-model="cond.case_industry_id" @change="readList"></industry>
      <areas v-model="cond.case_business_id" @change="readList"></areas>
    </div>
    <a-spin :spinning="loading">
      <a-row :gutter="30" v-if="data.length">
        <a-col :sm="8" v-for="(item, ind) in data" :key="ind">
          <div class="pb-30 case-page-mo">
            <card
              :imgurl="item.case_poster_url"
              :title="item.case_title"
              :industries="item.case_industry_title_zh"
              :areas="item.case_business_title_zh"
              @click="$router.push('./cases/' + item.code)">
            </card>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="30" v-else>
        <a-col :sm="8" v-for="(item, ind) in 3" :key="ind">
          <div class="pb-30 case-page-mo">
            <card></card>
          </div>
        </a-col>
      </a-row>
    </a-spin>
    <div class="pagination-style" v-if="data.length">
      <a-pagination
        :default-current="1"
        :total="total"
        :page-size="cond.page_size"
        @change="onChange" />
    </div>
  </fo-layout>
</template>

<script>
import card from './comps/cardCases.vue'
import industry from './comps/selectedIndustry.vue'
import areas from './comps/selectedAreas.vue'
export default {
  components: {
    card,
    areas,
    industry
  },
  data () {
    return {
      loading: false,
      total: 0,
      data: [],
      cond: {
        case_industry_id: undefined,
        case_business_id: undefined,
        page_num: 1,
        page_size: 6
      }
    }
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  mounted () {
    this.readList()
  },
  methods: {
    onChange (current, pageSize) {
      window.scroll(0, (this.$refs.filter.offsetTop - 130))
      this.cond.page_num = current
      this.readList()
    },
    readList () {
      this.loading = true
      this.get({
        url: 'casesRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        if (res.code) {
          this.data = res.data.items
          this.total = res.data.total
        } else {
          this.data = []
          this.total = 0
        }
      })
    }
  }
}
</script>

<style lang="less">
@media screen and (max-width: 751px) and (min-width: 300px) {
}
/* 大于 750 */
@media screen and (min-width: 751px) {
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/casesAll.vue